import { IonButton } from "@ionic/react";

interface Props {
    setAssesmentType: Function;
}
const SelectAssesmentTypeModal: React.FC<Props> = ({ setAssesmentType }) => {
    return (
        <>

            <div className="assesment-type-modal-wrapper">
                <h2>Assesment Type </h2>
                <p>What type of assesment test do you want to perform ?</p>
                <div className="btn-list">
                <IonButton className="assesment-btn-type" expand="block" placeholder={undefined}>Assesment Type 1</IonButton>
                <IonButton className="assesment-btn-type" expand="block" placeholder={undefined}>Assesment Type 2</IonButton>
                <IonButton className="assesment-btn-type" expand="block" placeholder={undefined}>Assesment Type 3</IonButton>
                </div>
                
            </div>
        </>
    );
};
export default SelectAssesmentTypeModal;

